import React from "react";
import PageHero from "../components/PageHero";
import CategoryCard from "../components/CategoryCard";
import CTASection from "../components/CTASection";
import { PRODUCT_CATEGORIES } from "../lib/constants";

const RENEWABLE_SLUGS = new Set([
  "renewable-energy",
  "solar-street-lighting",
  "high-mast-led-lighting",
]);
const ITCCTV_KEYWORDS = ["cctv", "it-smart"];

function targetForCategory(slug) {
  if (RENEWABLE_SLUGS.has(slug)) return "/renewable-energy";
  if (ITCCTV_KEYWORDS.some((k) => slug.includes(k))) return "/it-cctv-smart-classroom";
  return "/institutional";
}

export default function Products() {
  return (
    <div>
      <PageHero
        kicker="Products & Services"
        title="Multi-Category Institutional Supply & Infrastructure"
        description="Renewable energy, lighting, electrical, CCTV, IT, furniture, kitchen, FMCG and requirement-based fulfilment."
        primary={{ to: "/submit", label: "Submit Requirement" }}
        secondary={{ to: "/downloads", label: "Download Profile" }}
        image="/img/institutional-supplies.png"
      />

      <section className="section">
        <div className="container-x">
          <div className="grid-cards">
            {PRODUCT_CATEGORIES.map((c) => (
              <CategoryCard
                key={c.slug}
                title={c.name}
                desc={c.desc}
                icon={c.icon}
                items={c.items}
                to={targetForCategory(c.slug)}
              />
            ))}
          </div>
        </div>
      </section>

      <CTASection
        title="Need a custom requirement?"
        description="From a single category to multi-category bulk supply — share your requirement and we will revert with the right solution."
      />
    </div>
  );
}
